import { Component, HostBinding, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { NightModeService, OfflineService, PictureBackgroundService, ThemesService } from "@core";
import { Theme } from "@model";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  isPictureBackground$: Observable<boolean>;
  currentTheme$: Observable<Theme>;

  isNightMode = false;

  @HostBinding("class") class = "app-view";
  @HostBinding("class.night-mode") get getIsNightMode(): boolean {
    return this.isNightMode;
  }

  constructor(
    private _translateService: TranslateService,
    private _nightModeService: NightModeService,
    private _themesService: ThemesService,
    private _pictureBackgroundService: PictureBackgroundService,
    private _offlineService: OfflineService, // do not remove
  ) {
    this._setAppHeight();
    this._setUpLocale();

    this.isPictureBackground$ = this._pictureBackgroundService.isPictureBackground$;
    this.currentTheme$ = this._themesService.currentTheme$;

    this._nightModeService.isNightMode$.subscribe((v) => {
      this.isNightMode = v;
    });

    // setTimeout(() => {
    //   throw('some funky error.')
    // }, 100)
  }

  private _setAppHeight(): void {
    const documentHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    window.addEventListener("resize", documentHeight);
    window.addEventListener("orientationchange", () => {
      documentHeight();

      document.documentElement.style.height = `initial`;
      setTimeout(() => {
        document.documentElement.style.height = `100%`;
        setTimeout(() => {
          // this line prevents the content
          // from hiding behind the address bar
          window.scrollTo(0, 1);
        }, 500);
      }, 500);
    });
    documentHeight();

    document.addEventListener(
      "dblclick",
      function (event) {
        event.preventDefault();
      },
      { passive: false },
    );
  }

  private _setUpLocale(): void {
    this._translateService.currentLang = "";
    this._translateService.use("de-DE");
  }
}
